import React from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles((theme) => ({
    checkboxLabel: {
        color: theme.palette.secondary.main,
        fontWeight: 'bold',
    },
}))

const ApplyAllCheckbox = ({
    applyToAll,
    setApplyToAll,
    labelText,
    name = '',
}) => {
    const classes = useStyles()

    return (
        <div>
            <FormControlLabel
                control={
                    <Checkbox
                        data-testid={`${name}-apply-all-checkbox`}
                        color="secondary"
                        icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                        checkedIcon={<CheckBoxIcon fontSize="large" />}
                        value={applyToAll}
                        checked={applyToAll}
                        onChange={(e) => {
                            setApplyToAll(e.target.checked)
                        }}
                    />
                }
                label={
                    <Typography className={classes.checkboxLabel}>
                        {labelText}
                    </Typography>
                }
            />
        </div>
    )
}

export default ApplyAllCheckbox
